import { ReactNode } from "react";
import { EntryAllocation } from "../types";

function parseDescription(text: string, normalClass: string, boldClass: string): ReactNode[] {
  return text.split(/(\*\*.*?\*\*)/).map((segment, i) => {
    if (segment.startsWith("**") && segment.endsWith("**")) {
      return (
        <span key={i} className={boldClass}>
          {segment.slice(2, -2)}
        </span>
      );
    }
    return (
      <span key={i} className={normalClass}>
        {segment}
      </span>
    );
  });
}

interface EntryCardProps extends EntryAllocation {}

export default function EntryCard({
  icon,
  count,
  description,
  isExclusiveBonus,
  exclusiveTag,
  exclusiveDescription,
}: EntryCardProps) {
  if (isExclusiveBonus) {
    return (
      <div className="relative flex items-start justify-center overflow-hidden p-3 lg:px-4 lg:py-6 lg:flex-1 lg:min-w-[160px] lg:min-h-[152px] gap-0.5 bg-[linear-gradient(75.6deg,#d7185d_12.8%,#24339f_86.3%)] rounded-xl outline outline-1 outline-black/[0.08] -outline-offset-1">
        <div className="absolute flex items-center justify-center px-2 py-0.5 right-0 top-0 bg-[#fff600] rounded-bl-xl">
          <p className="m-0 p-0 text-[11px] lg:text-xs font-medium font-jost leading-3.5 lg:leading-4 text-black whitespace-nowrap">
            {exclusiveTag}
          </p>
        </div>

        <div className="flex flex-col items-start w-full min-w-0 gap-0.5">
          <div className="flex items-center min-h-[30px]">
            <img src={icon} alt="" className="w-auto h-6 lg:h-[30px] shrink-0" />
          </div>
          <div className="flex flex-col items-start w-full gap-0.5">
            <p className="m-0 p-0 text-base lg:text-xl font-bold font-jost leading-5.5 lg:leading-6.5 text-white whitespace-nowrap">
              {count}
            </p>
            <p className="m-0 p-0 min-h-8 lg:min-h-[44px] text-[12px] lg:text-base font-jost leading-4 lg:leading-5.5">
              {/* <span className="text-white/60 font-medium">into</span>{" "} */}
              <span className="text-white/80 font-semibold">
                {exclusiveDescription}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start p-3 lg:px-4 lg:py-6 lg:flex-1 lg:min-w-[160px] lg:min-h-[152px] bg-white rounded-xl outline outline-1 outline-black/[0.08] -outline-offset-1">
      <div className="flex flex-col items-start min-w-0 lg:gap-0.5">
        <div className="flex items-center min-h-[30px]">
          <img src={icon} alt="" className="w-auto h-6 lg:h-[30px] shrink-0" />
        </div>
        <div className="flex flex-col items-start w-full gap-0.5">
          <p className="m-0 p-0 text-base lg:text-xl font-bold font-jost leading-5.5 lg:leading-6.5 text-primary whitespace-nowrap">
            {count}
          </p>
          <p className="m-0 p-0 min-h-8 lg:min-h-[44px] text-[12px] lg:text-base font-jost leading-4 lg:leading-5.5 min-w-0">
            {parseDescription(description, "text-[#696971] font-medium", "text-[#4C4C52] font-semibold")}
          </p>
        </div>
      </div>
    </div>
  );
}
